module.exports = __webpack_public_path__ + "img/envelope2.67d679ec.svg";